import { useEffect, useState } from "react";
import { NetworkGraphic } from "./Brand";

export const ImageFallback = ({ alt }) => (
  <div
    role="img"
    aria-label={`${alt || "Image"} — image not yet available`}
    className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-pale p-4 text-center"
    data-testid="image-fallback"
  >
    <NetworkGraphic className="h-1/2 max-h-32 w-auto opacity-80" node="#082F6B" line="#082F6B" />
    <span className="text-xs font-semibold text-ink-muted">Image to be added</span>
  </div>
);

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const SmartImage = ({ src, alt, ratio = "aspect-[16/10]", className = "", imgClassName = "", testId }) => {
  const [failed, setFailed] = useState(!src);
  useEffect(() => {
    setFailed(!src);
  }, [src]);
  return (
    <div className={`relative overflow-hidden bg-mist ${ratio} ${className}`} data-testid={testId}>
      {failed ? (
        <ImageFallback alt={alt} />
      ) : (
        <img src={mediaUrl(src)} alt={alt} loading="lazy" onError={() => setFailed(true)} className={`h-full w-full object-cover ${imgClassName}`} />
      )}
    </div>
  );
};

// Single shared rule for story cover images: 16:9 box reserved up front, centred cover crop.
export const STORY_IMAGE_RATIO = "aspect-video";
export const StoryImage = ({ className = "", ...props }) => <SmartImage {...props} ratio={STORY_IMAGE_RATIO} className={className} imgClassName={`object-center ${props.imgClassName || ""}`} />;

// Shows an admin-chosen image when set, otherwise the built-in illustration.
export const Swappable = ({ src, alt = "", className = "", children }) =>
  src ? <img src={mediaUrl(src)} alt={alt} aria-hidden={alt ? undefined : true} className={className} /> : children;

export const HeroBackdrop = ({ src, children }) =>
  src ? (
    <>
      <img src={mediaUrl(src)} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover" />
      <div className="pointer-events-none absolute inset-0 bg-brand/80" aria-hidden="true" />
    </>
  ) : children;
